import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { memo } from "react";
export const InfoPanelDetailTitle = /*#__PURE__*/ memo((param)=>{
    let { className, ...props } = param;
    return /*#__PURE__*/ _jsx("h3", {
        className: tailwindMerge("line-clamp-2 text-14 text-grey-12", className),
        ...props
    });
});
InfoPanelDetailTitle.displayName = "InfoPanelDetailTitle";
